<template>
  <v-row>
    <v-col>
      <v-autocomplete
        :items="places"
        :rules="[required]"
        item-value="short_name"
        :item-text="item => `(${item.short_name}) ${item.stop_name}`"
        :filter="
          (item, query) =>
            item.short_name.toLowerCase().includes(query.toLowerCase()) ||
            item.stop_name.toLowerCase().includes(query.toLowerCase())
        "
        outlined
        label="Plats"
        v-model="location_place"
      />
    </v-col>
    <v-col cols="3">
      <v-text-field
        :rules="[validTime]"
        v-model="time"
        type="time"
        label="Tid"
        :disabled="model.type === 'RST'"
        outlined
      />
    </v-col>
    <v-col cols="3">
      <v-text-field
        label="Försening (min)"
        outlined
        type="number"
        v-model.number="model.delay"
        :rules="[required]"
      />
    </v-col>
  </v-row>
</template>

<script>
import { format } from 'date-fns'
import { sync, get } from 'vuex-pathify'
import { validTime, required } from '@/common/validationRules'

export default {
  name: 'DelayLocationFields',

  data: () => ({
    required,
    validTime,
    time: null
  }),

  computed: {
    stops: get('event/stops'),
    model: get('delay/model'),
    location_place: sync('delay/model@location_place'),
    locationTime: get('delay/model@location_time'),
    advertisedPlaces: get('delay/advertisedPlaces'),

    places() {
      return this.model.type === 'RST' && this.advertisedPlaces.length
        ? this.advertisedPlaces
        : this.stops
    }
  },

  created() {
    const locationTime = new Date(this.locationTime)
    this.date = format(locationTime, 'yyyy-MM-dd')
    this.time = format(locationTime, 'HH:mm')
  },

  watch: {
    location_place: {
      handler(value) {
        if (
          !value ||
          this.model.type !== 'RST' ||
          !this.advertisedPlaces.length
        ) {
          this.time = format(new Date(this.locationTime), 'HH:mm')
          return
        }
        const place = this.advertisedPlaces.find(x => x.short_name === value)
        this.$store.set('delay/model@location_time', place.advertised)
        this.$store.set('delay/model@delay', place.delay)
        this.time = format(new Date(place.advertised), 'HH:mm')
      },
      immediate: true
    },

    time(input) {
      if (this.model.type === 'RST') return
      const date = format(new Date(this.locationTime), 'yyyy-MM-dd')
      const location_time = new Date(`${date} ${input}`)
      this.$store.set('delay/model@location_time', location_time)
    }
  }
}
</script>
